// hooks/useProjectId.ts
import { useMatch } from "react-router-dom";

export function useProjectId() {
  const match = useMatch("/:projectId/*");
  return Number(match?.params.projectId) ?? 0;
}
